export const calculateMaxTouchlessPurchasableQuantity = quantity => {
  return typeof quantity !== 'number' ? Infinity : quantity;
};
export const getMaxAdditionalUnits = quantityPack => {
  var _quantityPack$include;
  const maxTouchlessPurchasableQuantity = calculateMaxTouchlessPurchasableQuantity(quantityPack.maxTouchlessPurchasableQuantity);
  const includedWithQuantityPack = (_quantityPack$include = quantityPack.includedWithQuantityPack) !== null && _quantityPack$include !== void 0 ? _quantityPack$include : 0;
  return includedWithQuantityPack * maxTouchlessPurchasableQuantity;
};
export const createSteppingFunction = (min, max, step) => (input, roundUp = false) => {
  return Math.min(Math[roundUp ? 'ceil' : 'round']((Math.max(input, min) - min) / step) * step + min, max - (max - min) % step);
};
export const getQuantityPackSteppingFunction = quantityPack => {
  const maxAdditionalUnits = getMaxAdditionalUnits(quantityPack);
  const {
    includedWithQuantityPack
  } = quantityPack;
  return createSteppingFunction(0, maxAdditionalUnits - maxAdditionalUnits % ( // avoid division by zero
  includedWithQuantityPack !== null && includedWithQuantityPack !== void 0 ? includedWithQuantityPack : 1), includedWithQuantityPack !== null && includedWithQuantityPack !== void 0 ? includedWithQuantityPack : 0);
};